import { textFilterDefaults } from "../text-column";

export const numberInEqFilterDefaults = {
  FilterComponent: textFilterDefaults.FilterComponent,
  createFilter: textFilterDefaults.createInEqTextFilter,
};
